export const makeRequest = async (url, token = null, tenantId = null, method = 'GET', data = {}, contentType = 'application/json') => {
    const options = {
        method
    };

    const headers = options.headers || {};

    if(method !== 'GET') {
        options.body = JSON.stringify(data);
        headers['Content-Type'] = contentType;
    }

    if(token) headers['Authorization'] = `Bearer ${token}`;

    if(tenantId) headers['Makrwatch-Tenant-Id'] = tenantId;

    if(Object.keys(headers).length > 0) {
        options.headers = headers;
    }

    const response = await fetch(url, options);
    return response.json();

};